import React, { useState } from "react";
import Style from "./ModalForm.module.scss";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import { useForm } from "../../logic/useForm";
import { customerForm } from "../../store/slices/formSlice";

const ModalForm = ({ becomePop, setModalShow, successMessage, setSuccessMessage }) => {
  const { formKey } = useForm();
  const [captchaReset, setCaptchaReset] = useState(false);
  const [loading, setLoading] = useState(false);

  const [captchaValid, isCaptchaValid] = useState(false);
  const [errorMsg, setErrorMsg] = useState(false);

  const phoneRegExp = /^(0*[1-9][0-9]*(\.[0-9]*)?|0*\.[0-9]*[1-9][0-9]*)$/;

  const validationSchema = Yup.object().shape({
    modal_full_name: Yup.string().required("Name is required"),
    modal_email: Yup.string().required("Email is required").email("Email is invalid"),
    emirates_id: Yup.string()
      .required("Emirates Id is required")
      .min(15, "Minimum 15 digit is required "),
    googleCaptcha: Yup.string().required("reCaptcha is required"),
    modal_mobile_number: Yup.string()
      .matches(phoneRegExp, "*Invalid mobile number")
      .required("Mobile number required")
      .min(8, "Minimum 8 digit is required "),
  });

  const formik = useFormik({
    initialValues: {
      modal_full_name: "",
      modal_email: "",
      modal_mobile_number: "",
      emirates_id: "",
      form_nonce: formKey?.nonce,
      key: formKey?.key,
      googleCaptcha: "",
    },
    validationSchema,
    enableReinitialize: true,

    onSubmit: (data) => {
      if (captchaValid) {
        formik.resetForm();
        enquirySubmit(data);
        setCaptchaReset(true);
        setLoading(true);
      }
    },
  });
  const dispatch = useDispatch();

  const changeCaptcha = (value) => {
    if (value) {
      isCaptchaValid(true);
    }
  };

  const enquirySubmit = async (data) => {
    var payload = new URLSearchParams();
    payload.append("full_name", data.modal_full_name);
    payload.append("email_address", data.modal_email);
    payload.append("mobile_number", data.modal_mobile_number);
    payload.append("emirates-id", data.emirates_id);
    payload.append("form_nonce", data.form_nonce);
    payload.append("key", data.key);

    const resultAction = await dispatch(customerForm(payload));

    if (customerForm.fulfilled.match(resultAction)) {
      setErrorMsg(resultAction?.payload?.data?.data?.[0]?.message);
      setTimeout(() => {
        setErrorMsg(false);
      }, 2500);
      setSuccessMessage(resultAction?.payload?.data?.success);
      setLoading(false);
      successMessage(true);
      setModalShow(true);
      setCaptchaReset(false);
    }
  };

  const { footerData } = useSelector((state) => state.footer);

  let cookieContent = footerData?.details?.footer_more_details;

  return (
    <>
      <div className={Style.fotmheader}>
        <div className={`h4 ${Style.formtitle}`}>{cookieContent?.become_customer_title}</div>
        <p>{cookieContent?.become_customer_content}</p>
      </div>
      {/* <iframe width="410px" height="380px" src={`/zoho.html`}></iframe> */}
      <iframe
        // frameborder="0"
        src="https://forms.zohopublic.com/SharafExchange/form/BecomeaCustomer/formperma/_giiZpXE8BOLRCQEl87fxUr1JFDJYtmuihGGN4Vnxzo"
      ></iframe>

    </>
  );
};

export default ModalForm;
